<template>
  <tr class="leads-external-marketing-automation-manage-item">
    
    <td>
      {{ item.databaseName }}
    </td>

    <td>
      {{ item.automationFlowName }}
    </td>  

    <td>
      {{ status }}
    </td> 

    <td>
      {{ formattedDate }}
    </td>
    
    <td v-if="item.status !== 'SENT'"
        class="leads-external-marketing-automation-manage-item-actions">
        <i class="leads-external-marketing-automation-manage-item-actions-item mdi mdi-square-edit-outline pointer"
            v-tooltip="$t('message.generics.message.edit')"
            @click="openEditModal"></i>
        <i class="leads-external-marketing-automation-manage-item-actions-item mdi mdi-delete pointer"
            v-tooltip="$t('message.generics.message.delete')"
            @click="openDeleteModal"></i>
    </td>

    <LeadsExternalMarketingAutomationCreateModal v-model="showingEditModal"
                                                 :item="item"
                                                 @edited="emitReload"
                                                 @reload="emitReload"/>

    <confirmation-modal :value="showingDeleteConfirmModal"
                        confirm-label="Confirmar"
                        @confirm="deleteMarketingAutomationSend"
                        @cancel="closeDeleteModal">
      <span slot="heading">
        {{ $t('message.loginPersonalize.message.deleteLoginType') }}
      </span>
      <span>
        {{ $t('message.loginPersonalize.message.deleteLoginTypeConfirmation') }}
      </span>
    </confirmation-modal>
    
  </tr>
</template>
  
<script>
import ConfirmationModal from "@components/ConfirmationModal";
import EventBus from "../../../../../../../packages/event-bus";
import LeadsExternalMarketingAutomationCreateModal from "../../create/modal/LeadsExternalMarketingAutomationCreateModal.vue";

export default {
  components: {
    ConfirmationModal,
    LeadsExternalMarketingAutomationCreateModal
  },

  data() {
    return {
      showingDeleteConfirmModal: false,
      showingEditModal: false
    };
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    status() {
      return {        
        ["SCHEDULED"]: this.$t('message.marketingGenerics.message.scheduled'),
        ["SENT"]: this.$t('message.marketingGenerics.message.sent')        
      }[this.item.status];
    },
    formattedDate() {
      let fomattedDateAndTime
      if(this.item.date) {
        const date = this.item.date.split(" ")[0]
        const time = this.item.date.split(" ")[1]
        const dateArray = date.split("-")
        const timeArray = time.split(":")
        fomattedDateAndTime = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]} - ${timeArray[0]}:${timeArray[1]}`
      }
      return fomattedDateAndTime
    }
  },

  methods: {
    emitReload() {
      this.$emit("reload");
    },
    openDeleteModal() {
      this.showingDeleteConfirmModal = true;
    },
    closeDeleteModal() {
      this.showingDeleteConfirmModal = false;
    },
    openEditModal() {
      this.showingEditModal = true;
    },
    async deleteMarketingAutomationSend() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        await this.$api.leads.deleteMarketingAutomationSend(this.item.id);

        EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t('message.successMessages.message.marketingSendDeleted'),
        });

        this.closeDeleteModal();

        this.$emit("deleted");
      } catch (error) {
        //empty
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    }
  },
};
</script>
  
<style lang="scss" scoped>
  .leads-external-marketing-automation-manage-item {

    .leads-external-marketing-automation-manage-item-actions {
      display: flex;
      align-items: center;

      .leads-external-marketing-automation-manage-item-actions-item {
        margin-right: 5px;

        &:last-child {
            margin-right: 0;
        }
      }
    }
  }
  
  
</style>
  